import React from 'react';
import {
    createMuiTheme,
    makeStyles,
    ThemeProvider,
    CssBaseline,
} from '@material-ui/core';
import { Notification } from 'react-admin';

import { theme } from '../theme';
import { Footer } from './Footer';
import { Header } from './Header';

export const UnAuthenticatedLayout = ({ children, showActions }) => {
    const classes = useStyles();

    return (
        <>
            <Header showActions={showActions} />
            <main className={classes.main}>{children}</main>
            <Footer />
            <Notification />
        </>
    );
};

export const UnAuthenticatedLayoutWithTheme = props => {
    return (
        <ThemeProvider theme={createMuiTheme(theme)}>
            <CssBaseline />
            <UnAuthenticatedLayout {...props} />
        </ThemeProvider>
    );
};

const useStyles = makeStyles(
    theme => ({
        '@global': {
            body: {
                background: theme.palette.common.white,
                color: theme.palette.common.white,
            },
            '#root': {
                minHeight: '100vh',
            },
        },
        main: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        },
    }),
    {
        name: 'HealthcareUnAuthenticatedLayout',
    }
);
